import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=22746469&"
import script from "./Coupon.vue?vue&type=script&lang=js&"
export * from "./Coupon.vue?vue&type=script&lang=js&"
import style0 from "./Coupon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VEditDialog,VIcon,VTextField})
